export const locationsEn = {
  locations: {
    type: {
      factory: 'Factory',
      office: 'Office',
      unknown: 'Unknown',
    },
  },
  header: {
    selectLocation: 'Select Location',
    searchLocations: 'Search locations...',
    allLocations: 'All Locations',
  },
}
